import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { LoyaltyProgramData } from "../../../data/types"

export const LOYALTY_PROGRAM_MOUNTED = "LOYALTY_PROGRAM_MOUNTED"

export const loyaltyProgramMounted = () => ({
    type: LOYALTY_PROGRAM_MOUNTED,
})

export const LOYALTY_FORM_SUBMITTED = "loyalty/form/submitted"

export const loyaltyFormSubmitted = (oldValue: Maybe<LoyaltyProgramData>, newValue: LoyaltyProgramData) => ({
    type: LOYALTY_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const LOYALTY_UNSUBSCRIBE_CLICKED = "loyalty/form/unsubscribe"

export const loyaltyFormUnsubscribeClicked = (id: string) => ({
    type: LOYALTY_UNSUBSCRIBE_CLICKED,
    payload: {
        id: id,
    },
})
